/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import { useWebhooks } from "../api/hooks.js";
import { session } from "../stores/session.js";
import { WebhooksScreen } from "../screens/WebhooksScreen.js";

export function WebhooksRoute(): VNode {
  const { webhooks, resource, deleteWebhook } = useWebhooks();
  const hasToken = Boolean(session.value.token);

  return (
    <WebhooksScreen
      webhooks={hasToken ? (webhooks ?? []) : undefined}
      webhooksResource={hasToken ? resource : undefined}
      onDeleteWebhook={hasToken ? deleteWebhook : undefined}
    />
  );
}
